const PHRASES = [
  "Hand-painted in oil & acrylic",
  "One of a kind",
  "Personal atelier consultation",
  "Celebrating the bond",
  "No digital shortcuts",
  "Signed originals only",
];

export const Marquee = () => {
  const row = [...PHRASES, ...PHRASES];
  return (
    <div data-testid="editorial-marquee" className="relative border-y border-stone-800/70 bg-[#100D0A] py-5 overflow-hidden">
      <div className="animate-marquee-drift flex w-max items-center whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((p, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif italic text-lg sm:text-xl text-[#F0F8FC]/80 px-6">{p}</span>
                <span className="text-[#41C2F2] text-xs">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
